var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resendTimer)?_c('p',[_vm._v("\n  "+_vm._s(_vm.$t(_vm.timeoutTextTranslateKey, _vm.timeoutTextDefault, { timer: _vm.resendTimer }))+"\n")]):_c('invisible-recaptcha',{staticClass:"captcha-class-btn",attrs:{"sitekey":_vm.recaptchaKey,"callback":_vm.resend}},[_c('TextWithLinks',{staticClass:"verify-msg-submit",class:{ 'is-loading': _vm.isLoadingResend },attrs:{"tag":"p","content":_vm.resendTextDefault,"content-props":{
      resend: {
        text: 'Resend',
        fn: _vm.resend,
      },
    },"translate-key":_vm.resendTextTranslateKey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }